import { motion, useReducedMotion } from 'framer-motion'

import Banner from './modules/banner'
import Statistics from './modules/statistics'
import Trust from './modules/trust'
import Thesis from './modules/thesis';
import Publish from './modules/publish';
import Introduce from './modules/introduce';
import Stack from '@/components/Stack';
import Testimonials from './modules/testimonials';

import './index.scss'

const sectionVariants = {
  hidden: {
    opacity: 0,
    y: 36,
  },
  visible: {
    opacity: 1,
    y: 0,
  },
}

const reducedSectionVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
}

const homeSections = [
  {
    key: 'hero',
    label: 'Hero',
    component: <Banner />,
    skipMotion: true,
  },
  {
    key: 'problem',
    label: 'Problem',
    component: <Thesis />,
  },
  {
    key: 'introduce',
    label: 'Introduce',
    component: <Introduce />,
  },
  {
    key: 'logo-ticker',
    label: 'Logo Ticker',
    component: <Trust />,
  },
  {
    key: 'traction',
    label: 'Traction',
    component: <Statistics />,
  },
  {
    key: 'publish',
    label: 'Publish',
    component: <Publish />,
  },
  {
    key: 'testimonials',
    label: 'Testimonials',
    component: <Testimonials />,
  },
  {
    key: 'stack',
    label: 'Stack',
    component: <Stack />,
  },
]

const Home = () => {
 const shouldReduceMotion = useReducedMotion()
 const variants = shouldReduceMotion ? reducedSectionVariants : sectionVariants

 return (
   <div style={{background:'#101010'}} id="home">
     {homeSections.map((section) => {
       if (section.skipMotion) {
         return (
           <section key={section.key} aria-label={section.label}>
             {section.component}
           </section>
         )
       }

       return (
         <section
           key={section.key}
           className="home-motion-screen"
           aria-label={section.label}
         >
           <motion.div
             className="home-motion-content"
             initial="hidden"
             whileInView="visible"
             viewport={{ amount: 0.18, once: true, margin: '0px 0px -8% 0px' }}
             variants={variants}
             transition={{
               duration: shouldReduceMotion ? 0.2 : 0.95,
               ease: [0.16, 1, 0.3, 1],
               opacity: { duration: shouldReduceMotion ? 0.2 : 0.75, ease: 'easeOut' },
               delay: 0.02,
             }}
           >
             {section.component}
           </motion.div>
         </section>
       )
     })}

   </div>
 )
}

export default Home
